import Axios from 'axios'

const label = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.LABEL_URL
    return AxiosInstance
  },
  getLabel (barcode) {
    return this.axios().get('label?barcode=' + barcode)
  },
}

export default label
